import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "./store";

// Configuration de fetchBaseQuery pour toutes les requêtes API
const baseQuery = fetchBaseQuery({
  baseUrl: `${import.meta.env.VITE_API_URL}/api/v1/s/`, // URL de base pour toutes les requêtes
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token; // Récupération du Token d'authentification depuis Redux.
   if (token) {
      headers.set("Authorization", `Bearer ${token}`); // Ajout du Token d'authentification aux headers de la requête
    }
    return headers;
  },
});

// Création de l'API avec Redux Toolkit
export const apiSlice = createApi({
  reducerPath: "api", // Nom sous lequel le reducer sera monté dans le store Redux
  baseQuery, // Utilisation de fetchBaseQuery configuré précédemment
  tagTypes: ["User", "Tab"], // Définition des types de tags pour l'invalidation du cache et la gestion des données
  endpoints: () => ({
    // Définition des endpoints (requêtes API) , il sont définit sur un fichier séparé.
  }),
});
